export const versionInformation = {
  AppVersion: '1.6.4'
};

